import { z } from 'zod';

export const aiSequenceSchema = z.object({
	offering: z
		.string()
		.min(10, 'Offering must be at least 10 characters')
		.max(500, 'Offering must be at most 500 characters'),
	targetAudience: z
		.string()
		.min(10, 'Target audience must be at least 8 characters')
		.max(500, 'Target audience must be at most 500 characters'),
	valueProposition: z
		.string()
		.max(1000, 'Value proposition must be at most 1000 characters'),
	signature: z
		.string()
		.max(500, 'Signature must be at most 500 characters')
		.optional()
});

export type AiSequenceSchemaProps = z.infer<typeof aiSequenceSchema>;
